import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconChevronLeft.tsx
const OutlinedFilledChevronLeft = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M561-216 296-481l265-265 67 67-198 198 198 198-67 67Z" })
});
const OutlinedChevronLeft = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M561-216 296-481l265-265 67 67-198 198 198 198-67 67Z" })
});
const RoundedFilledChevronLeft = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m430-481 165 165q14 14 13.5 33T594-250q-14 14-33.5 14T527-250L330-447q-7-7-11-16t-4-18q0-9 4-18t11-16l198-198q14-14 33.5-14t33.5 14q14 14 14 33.5T595-646L430-481Z" })
});
const RoundedChevronLeft = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m430-481 165 165q14 14 13.5 33T594-250q-14 14-33.5 14T527-250L330-447q-7-7-11-16t-4-18q0-9 4-18t11-16l198-198q14-14 33.5-14t33.5 14q14 14 14 33.5T595-646L430-481Z" })
});
const SharpFilledChevronLeft = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M561-216 296-481l265-265 67 67-198 198 198 198-67 67Z" })
});
const SharpChevronLeft = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M561-216 296-481l265-265 67 67-198 198 198 198-67 67Z" })
});
const componentMap = {
	outlined: OutlinedChevronLeft,
	"outlined-fill": OutlinedFilledChevronLeft,
	rounded: RoundedChevronLeft,
	"rounded-fill": RoundedFilledChevronLeft,
	sharp: SharpChevronLeft,
	"sharp-fill": SharpFilledChevronLeft
};
const IconChevronLeft = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconChevronLeft };